import { createSlice, createAsyncThunk, Slice } from "@reduxjs/toolkit";
import { serviceInstance } from "utils/axiosInstances";

import { SearchResult } from "./types";

const search = createAsyncThunk(
  "resourceSearch/search",
  // use object as param because createAsync thunk has it's own methods
  // as the second param
  async ({ query, size }: { query: string; size?: number }) => {
    const response = await serviceInstance.get("/searchDocument", {
      params: { query, size },
    });

    return response.data as SearchResult;
  }
);

const initialState: SearchResult = [] as SearchResult;

const resourceSearchSlice: Slice = createSlice({
  name: "resourceSearch",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(search.fulfilled, (state, action) => {
      return action.payload;
    });
    builder.addCase(search.rejected, (state, action) => {
      return { error: action.error };
    });
  },
});

export { search };
export default resourceSearchSlice.reducer;
